export {default as setting} from './config.setting'
